<app-toast [message]="toast.message"></app-toast>

<div class="row">

  <div class="col-2 ps-0 sidebar">
    <app-sidebar [items]="menuItems" [current]="currentContent"></app-sidebar>
  </div>
  <div class="col-10 px-0">
    <app-loading [condition]="isLoading.politician"></app-loading>
    @if (!isLoading.politician) {
      <div class="card border-0">
        <h4 class="card-header border-0">
          Stakeholder <app-breadcrumb [menuItems]="menuItems" [currentContent]="currentContent"></app-breadcrumb>
        </h4>
        <div class="card-body pb-0">
          <div class="row row-cols-1 row-cols-lg-2">
            <div class="col mb-3 pr-lg-1">
              <app-stakeholder [politician]="politician"></app-stakeholder>
            </div>
            <div class="col mb-3">
              <div class="card h-100">
                <div class="card-body">
                  <h5 class="card-title">
                    Other info
                  </h5>
                  <div class="d-flex flex-column">
                    @if (politician.organ) {
                      <div>
                        <i class="fa fa-folder fa-fw me-1"></i> <a href="https://drive.google.com/drive/folders/1CudW_X_r4tk9gal6Jkl6rjydktxj4C6p" target="_blank">Bioprofile folder</a>
                      </div>
                    }
                    @if (politician.email) {
                      <div>
                        <i class="fa fa-envelope-o fa-fw"></i> {{politician.email}}
                        <button class="btn btn-sm btn-primary py-0 px-1 ms-1 hide-print" data-bs-toggle="modal" data-bs-target="#edit-stakeholder-details-modal" (click)="toggleEditStakeholderDetailsModal('email')">
                          <i class="fa fa-pencil"></i>
                        </button>
                      </div>
                    }
                    @if (politician.phone && politician.phone !== 'Unauthorized') {
                      <div>
                        <i class="fa fa-phone fa-fw"></i> {{politician.phone}}
                        <button class="btn btn-sm btn-primary py-0 px-1 ms-1 hide-print" data-bs-toggle="modal" data-bs-target="#edit-stakeholder-details-modal" (click)="toggleEditStakeholderDetailsModal('phone')">
                          <i class="fa fa-pencil"></i>
                        </button>
                      </div>
                    }
                    @if (!politician._organization) {
                      <div>
                        <button type="button" class="btn btn-sm btn-primary py-0 px-1 ms-1 hide-print" data-bs-toggle="modal" data-bs-target="#edit-stakeholder-details-modal" (click)="toggleEditStakeholderDetailsModal('_organization')">
                          <i class="fa fa-building"></i> Add third parties
                        </button>
                      </div>
                    }
                    @if (politician._organization) {
                      <div>
                        <i class="fa fa-building fa-fw me-1"></i>
                        <a [routerLink]="'/organization/' + politician._organization._id">{{politician._organization.name}}</a>
                        <button class="btn btn-sm btn-primary py-0 px-1 ms-1 hide-print" data-bs-toggle="modal" data-bs-target="#edit-stakeholder-details-modal" (click)="toggleEditStakeholderDetailsModal('_organization')">
                          <i class="fa fa-pencil"></i>
                        </button>
                      </div>
                    }
                    @if (politician.birthday) {
                      <div>
                        <i class="fa fa-birthday-cake fa-fw"></i> {{politician.birthday | date}} <small>({{currentYear-+(politician.birthday | date:'yyyy')}} years old)</small>
                      </div>
                    }
                    @if (politician.birthplace) {
                      <div>
                        <i class="fa fa-map-marker fa-fw me-1"></i>
                    <a target="_blank" [href]="'https://it.wikipedia.org/w/index.php?title=Speciale:Ricerca&go=Go&ns0=1&search=' + politician.birthplace">{{politician.birthplace}}</a>
                  </div>
}
                  @if (politician.education) {
<div>
                    <i class="fa fa-graduation-cap fa-fw"></i> {{politician.education.split(' ')[0]}}
                  </div>
}
                  @if (politician.college) {
<div>
                    <i class="fa fa-map-o fa-fw"></i> {{politician.college}}
                  </div>
}
                  @if (politician.organ !== 'European Parliament') {
                      <div>
                        <i class="fa fa-language fa-fw"></i> {{politician.english ? 'Speaks English' : 'Does not speak English'}}
                        <button class="btn btn-sm btn-primary py-0 px-1 ms-1 hide-print" data-bs-toggle="modal" data-bs-target="#edit-stakeholder-details-modal" (click)="toggleEditStakeholderDetailsModal('english')">
                          <i class="fa fa-pencil"></i>
                        </button>
                      </div>
                    }
                    <!-- Missing fields -->
                    @if (!politician.email) {
                      <div>
                        <button type="button" class="btn btn-sm btn-primary py-0 px-1 ms-1 hide-print" data-bs-toggle="modal" data-bs-target="#edit-stakeholder-details-modal" (click)="toggleEditStakeholderDetailsModal('email')">
                          <i class="fa fa-envelope-o"></i> Add email
                        </button>
                      </div>
                    }
                    @if (!politician.phone) {
                      <div>
                        <button type="button" class="btn btn-sm btn-primary py-0 px-1 ms-1 hide-print" data-bs-toggle="modal" data-bs-target="#edit-stakeholder-details-modal" (click)="toggleEditStakeholderDetailsModal('phone')">
                          <i class="fa fa-phone"></i> Add phone
                        </button>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row row-cols-1 row-cols-lg-3">
            <div class="col mb-3 pr-lg-1">
              <div class="card h-100">
                <div class="card-body">
                  <h5 class="card-title">
                    Notes
                    <button class="btn btn-sm btn-primary py-0 px-1 ms-1 hide-print" data-bs-toggle="modal" data-bs-target="#edit-stakeholder-details-modal" (click)="toggleEditStakeholderDetailsModal('notes')">
                      <i class="fa fa-pencil"></i> Edit
                    </button>
                  </h5>
                  @if (politician.notes) {
                    <div>
                      <p [innerHTML]="formatNotes(politician.notes)"></p>
                    </div>
                  }
                  @if (!politician.notes) {
                    <div>
                      Nothing found.
                    </div>
                  }
                  <hr>
                    @if (politician.socials?.twitter?.bio) {
                      <div>
                        <i class="fa fa-twitter"></i>
                        <i data-bs-toggle="tooltip" data-position="top" data-delay="350" title="Twitter bio">
                          {{politician.socials?.twitter?.bio}}
                        </i>
                      </div>
                    }
                  </div>
                </div>
              </div>
              <div class="col mb-3 pr-lg-1">
                <div class="card h-100">
                  <div class="card-body">
                    <h5 class="card-title">
                      Topics
                      <button class="btn btn-sm btn-primary py-0 px-1 ms-1 hide-print" data-bs-toggle="modal" data-bs-target="#edit-stakeholder-details-modal" (click)="toggleEditStakeholderDetailsModal('topics')">
                        <i class="fa fa-pencil"></i> Edit
                      </button>
                    </h5>
                    @if (politician.topics) {
                      <div>
                        {{politician.topics.sort().join(', ')}}
                      </div>
                    }
                    @if (!politician.topics?.length) {
                      <div>
                        Nothing found.
                      </div>
                    }
                  </div>
                  <div class="card-body">
                    <h5 class="card-title">
                      Team referent
                      <button class="btn btn-sm btn-primary py-0 px-1 ms-1 hide-print" data-bs-toggle="modal" data-bs-target="#edit-stakeholder-details-modal" (click)="toggleEditStakeholderDetailsModal('_users')">
                        <i class="fa fa-pencil"></i> Edit
                      </button>
                    </h5>
                    @if (politician._users?.length) {
                      <div class="mb-1">
                        @for (user of politician._users; track user; let last = $last) {
                          <span>
                            <a [routerLink]="'/user/' + user._id">
                              <img class="img-25 img-rounded" [src]="user.image || profilePics.default" alt=""> {{user.firstName}} {{user.lastName}}
                            </a>
                            @if (!last) {
                              <span>, </span>
                            }
                          </span>
                        }
                      </div>
                    }
                    @if (!politician._users?.length) {
                      <div>
                        No one.
                      </div>
                    }
                  </div>
                </div>
              </div>
              <div class="col mb-3">
                <div class="card h-100">
                  <div class="card-body">
                    <h5 class="card-title">
                      Socials
                      <button class="btn btn-sm btn-primary py-0 px-1 ms-1 hide-print" data-bs-toggle="modal" data-bs-target="#edit-stakeholder-details-modal" (click)="toggleEditStakeholderDetailsModal('socials')">
                        <i class="fa fa-pencil"></i> Edit
                      </button>
                    </h5>
                    <div>
                      <app-socials [item]="politician" side="left" text="yes"></app-socials>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
      <div class="card border-0">
        <h4 class="card-header border-0">
          Track record &amp; Activities
        </h4>
        @if (politician) {
          <ul class="nav nav-tabs ms-1" [ngClass]="{ 'disabled': isLoading.results }">
            <li class="nav-item">
              <a class="nav-link" [ngClass]="{ 'active disabled': currentTab === 'track-record' }" (click)="changeTab('track-record')">
                <i class="fa fa-list"></i>
                Track record
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" [ngClass]="{ 'active': currentTab === 'twitter', 'disabled': (currentTab === 'twitter' || !politician.socials?.twitter?.username) }" (click)="changeTab('twitter')">
                <i class="fa fa-twitter"></i>
                <span class="d-none d-md-inline-block ms-1">X</span>
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" [ngClass]="{ 'active disabled': currentTab === 'camera' }" (click)="changeTab('camera')">
                <img class="img-25 img-rounded" [src]="profilePics.camera" alt="">
                <span class="d-none d-md-inline-block ms-1">Camera</span>
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" [ngClass]="{ 'active fisabled': currentTab === 'senato' }" (click)="changeTab('senato')">
                <img class="img-25 img-rounded" [src]="profilePics.senato" alt="">
                <span class="d-none d-md-inline-block ms-1">Senato</span>
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" [ngClass]="{ 'active disabled': currentTab === 'eu' }" (click)="changeTab('eu')">
                <img class="img-25 img-rounded" [src]="profilePics.eu" alt="">
                <span class="d-none d-md-inline-block ms-1">European Parliament</span>
              </a>
            </li>
          </ul>
        }
        <div class="card-body tab-content">
          @if (currentTab === 'track-record' && !isLoading.results && results?.length) {
            <p>
              <span class="badge badge-primary">{{count}}</span> results found:
            </p>
          }
          @if (currentTab === 'track-record' && isLoading.results === false && results?.length === 0) {
            <p>
              Nothing found.
            </p>
          }
          @if (currentTab === 'track-record' && isLoading.results) {
            <p>
              <app-spinner [condition]="isLoading.results"></app-spinner>
            </p>
          }
          @if (currentTab === 'track-record' && results.length) {
            <div class="row row-cols-1 row-cols-lg-2" [ngClass]="{ 'disabled': isLoading.results }">
              @for (record of results; track record) {
                <div class="col mb-3">
                  <app-record [record]="record" [clients]="clients"></app-record>
                </div>
              }
            </div>
          }
          <div [hidden]="currentTab !== 'twitter'">
            <div class="row">
              <div class="col-lg-7">
                @if (false) {
                  <select class="form-control mb-3" name="twitterSort" [(ngModel)]="twitterSort" (change)="changeTwitterSort()">
                    <option value="" selected disabled>Sort tweets by</option>
                    <option value="date">Latest tweets</option>
                    <option value="impressions">Top impressions</option>
                    <option value="quotes">Top quotes</option>
                    <option value="retweets">Top retweets</option>
                    <option value="likes">Top likes</option>
                  </select>
                }
                @if (currentTab === 'twitter') {
                  <app-result [isLoading]="isLoading.results" [results]="results"></app-result>
                }
              </div>
              <div class="col-lg-5">
                @if (politician) {
                  <div class="card">
                    <h5 class="card-header border-0">
                      X statistics
                    </h5>
                    <div class="card-body d-flex flex-row justify-content-around">
                      <div class="text-center">
                        <h4>{{politician.socials?.twitter?.followers || 0}}</h4>
                        followers
                      </div>
                      <div class="text-center">
                        <h4>{{politician.socials?.twitter?.following || 0}}</h4>
                        following
                      </div>
                    </div>
                  </div>
                }
                <div class="card mt-3">
                  <h5 class="card-header border-0">
                    Followers per week
                    <a class="small float-end mt-1" [routerLink]="" (click)="exportChart(barChartFollowers, 'followers_per_week_' + politician.socials?.twitter?.username)"
                      data-bs-toggle="tooltip" data-position="top" data-delay="350" title="Download chart">
                      <i class="fa fa-download"></i>
                    </a>
                    <a class="small float-end me-3 mt-1" [routerLink]="" (click)="downloadCSV('statsByFollowers', 'date,followers')"
                      data-bs-toggle="tooltip" data-position="top" data-delay="350" title="Download CSV">
                      <i class="fa fa-database"></i>
                    </a>
                    <div class="btn-group me-3 float-end" role="group">
                      <select class="form-control form-control-sm" name="followersDate" [(ngModel)]="followersDate" (change)="changeFollowersDateRange()">
                        <option value="30">Last month</option>
                        <option value="90">Last 3 months</option>
                        <option value="180">Last 6 months</option>
                        <option value="360">Last year</option>
                      </select>
                    </div>
                  </h5>
                  <div class="card-body">
                    <canvas id="bar-chart1"></canvas>
                  </div>
                </div>
                <div class="card mt-3">
                  <h5 class="card-header border-0">
                    Top words
                    <a class="small float-end" [routerLink]="" (click)="exportChart(barChartTopWords, 'top_words_' + politician.socials?.twitter?.username)"
                      data-bs-toggle="tooltip" data-position="top" data-delay="350" title="Download chart">
                      <i class="fa fa-download"></i>
                    </a>
                    <a class="small float-end me-3" [routerLink]="" (click)="downloadCSV('topWords', 'word,occurrences')"
                      data-bs-toggle="tooltip" data-position="top" data-delay="350" title="Download CSV">
                      <i class="fa fa-database"></i>
                    </a>
                  </h5>
                  <div class="card-body">
                    <canvas id="bar-chart2"></canvas>
                  </div>
                </div>
              </div>
            </div>
          </div>
          @if (currentTab === 'camera') {
            <app-result [isLoading]="isLoading.results" [results]="results"></app-result>
          }
          @if (currentTab === 'senato') {
            <app-result [isLoading]="isLoading.results" [results]="results"></app-result>
          }
          @if (currentTab === 'eu') {
            <app-result [isLoading]="isLoading.results" [results]="results"></app-result>
          }
          @if (results.length) {
            <div>
              <div class="btn-group me-2">
                <button class="btn btn-primary" type="button" (click)="nextPrevPage(currentTab, 'prev')" [disabled]="page <= 0 || isLoading.results">
                  <i class="fa fa-chevron-left"></i>
                </button>
                <button class="btn btn-outline-primary" type="button" disabled>
                  Page: {{page + 1}}/{{math.floor(count / perPage + 1)}}
                </button>
                <button class="btn btn-primary" type="button" (click)="nextPrevPage(currentTab, 'next')" [disabled]="(count - (perPage * page)) <= perPage || isLoading.results">
                  <i class="fa fa-chevron-right"></i>
                </button>
              </div>
              <app-spinner [condition]="isLoading.results"></app-spinner>
            </div>
          }
        </div>
      </div>
    </div>

  </div>

  @if (isEditStakeholderDetailsModalVisible) {
    <app-edit-stakeholder-details-modal [politician]="politician" [field]="field"></app-edit-stakeholder-details-modal>
  }